import {PaymentStatus} from "./PaymentResponse";

export interface PaymentChargeResponse {
    error: string; // possibly localized
    errorUser: string; // possibly localized

    payment?: Payment;
    existing: boolean;
}

export interface Payment {
    timeTotalSec: number;
    timeRemainingSec: number;
    token: string;
    merchantId: number;
    amountFiat: number;
    status: PaymentStatus;
    email: string;
    // paidAmountCrypto: number;
    // remainingAmountCrypto: number;
    fiatCurrency: string;
    amountGateway: number;
    gatewayCurrency: string;
    couponCode: string;
    gateway: string; // enum short name
    descGateway: string;

    returnUrl: string; // URL to send the customer back to. may be empty

    //successPayImage: string; // image url, animated
    //successPayImageFinal: string; // image url
}

export function isSuccess(payment: Payment): boolean {
    return payment.status === "PAID"; // or redeemed timestmap set (status still paid)
}
